import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e9c1e8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = { class: "w-column-primary" }
const _hoisted_3 = { class: "w-topbar-aux" }
const _hoisted_4 = { class: "tech-flex column-content" }
const _hoisted_5 = { class: "calendar" }
const _hoisted_6 = {
  key: 0,
  class: "balance"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 3,
  class: "sidebar"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Confirm?")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"xx-small"} }, "minutes, negative for 'off' hours, positive for 'overtime' hours", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Confirm?", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "tech-flex tech-full-width" }
const _hoisted_15 = { class: "efforts" }
const _hoisted_16 = { class: "timeline-efforts" }
const _hoisted_17 = {
  key: 0,
  style: {"margin-top":"1em"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stopwatch" }, null, -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  style: {"margin-top":"1em"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { style: {"font-size":"300%"} }
const _hoisted_24 = {
  key: 3,
  style: {"margin-top":"1em"}
}
const _hoisted_25 = { style: {"width":"100%"} }
const _hoisted_26 = {
  key: 0,
  style: {"margin-left":"auto","padding":"0px 1em"}
}
const _hoisted_27 = {
  key: 1,
  class: "bi bi-box-arrow-right"
}
const _hoisted_28 = {
  key: 2,
  class: "clickable"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-right" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-in-right" }, null, -1))
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-right" }, null, -1))
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { class: "w-column-aux" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-topbar-aux-2" }, "Info", -1))

import EventComponent from '@/components/Workspaces/persons/_spec/EventComponent.vue';
import TicketCard from '@/components/Workspaces/tickets/_spec/TicketCard.vue';
import UserEdeavoursControl from '@/components/Workspaces/users/_spec/UserEdeavoursControl.vue'
import { endeavours as endeavours_get } from '@/controllers/workspaces/user.controller.workspace'
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { EffortSummary, SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';
import { useAppContext } from '@/app/_tech';
import { Sunrise, TimeSegment } from '@/logic/_infra/time';
import { onMounted, onUnmounted, reactive, ref, watch, onBeforeMount } from 'vue';
import personViewSetup, * as controller from '@/controllers/workspaces/person.controller'
import * as sys from '@/sys'
import * as lib from '@/lib'
import EndeavoursComponent from '@/app/workspace/person/timeline/EndeavoursComponent.vue'
import { Desk, Obligations } from '@/controllers/workspaces/person.controller'
import { computed } from '@vue/reactivity';
import EffortTimeline from '@/components/Workspaces/persons/_spec/EffortTimelineComponent.vue'
import AppointmentCreator from '@/components/Workspaces/_spec/AppointmentCreator.vue';
import { minuteCalc as mc } from '@/logic/_infra/time';
import AppContext from '@/context';
import userVueController from '@/components/Workspaces/users/_spec/user.controller.vue'
import * as array from '@/lib/array.lib'
import BalanceComponent from '@/components/Workspaces/_infra/time/BalanceControl.vue'
import dayjs from 'dayjs';
//C:\Work\mailnum\web.mn\src\app\workspace\person\timeline\timeline.controller.ts
import { setup } from '@/app/workspace/person/timeline/timeline.controller'
import { effortCss } from '@/controllers/workspaces/persons/effort.controller'
import { Guid } from '@/lib';
import { Timespending } from '@/app.context/workspace/Event';

import  EffortStatusComponent from '@/app/workspace/person/timeline/EffortStatusComponent.vue'


interface IObligationUiRow {

    date: Date
    factual: number
    nominal: number

}

interface ITimeOffUiRow extends IObligationUiRow {

    R: Date | null

}

const horizon = 21


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineSubview',
  props: {
    person: {},
    workspace: {}
  },
  setup(__props: any) {

const textbox = ref<InstanceType<typeof HTMLInputElement> | null>(null)


// declare a ref to hold the element reference
// the name must match template ref value
//const timeliner = ref<InstanceType<typeof EndeavoursComponent> | null>(null)

const context = useAppContext()

const workspace = computed(() => context.cursor.workspace)

const { user_level } = userVueController(context)




const person_model = computed(() => { return context.cursor.person })

const balance_today = computed(() => model.obligations.todayBalance(endeavours_segments.value))

const ui = reactive({ timeoff: { day: false, hour: false, hour_value: 0 }, appointment: false, date_aux: new Date() })

const endeavours_user = endeavours_get(context)

function onTimelinerUpdated(value: number[]) {

    const w = context.cursor.workspace;
    const p = context.cursor.person;




    //if (w != null && p != null && model.efforts .length > 0) {
    if (w != null && p != null && model.efforts != null) {

        const s = model.efforts.sunrise

        //const s = Sunrise.DateAsSunrise(model.date)

        context.storages.workspace!.personEndeavoursUpdate(w.wid, p.nid, s, value, lib.utcOffset())

    }

    endeavours_numbers_ui.replaceWith(value)

    //#trace console.log("Values on onTimelinerUpdated")
    //#trace console.log(value)
    //#trace console.log(endeavours_numbers_ui)
}

const props = __props

const model:
    {
        sunrise: Sunrise | null,
        date: Date,
        abscense: boolean,
        obligations: Obligations,
        efforts: SunriseReportRmodel | null,
        desk: Desk

    } = reactive({ person: null, sunrise: null, date: new Date(), abscense: false, endeavours: [], obligations: new Obligations(), efforts: null, desk: new Desk() })

const { remainder, endeavours_numbers_ui, endeavours_segments, isToday } = setup(model, context)

const endeavours_period = computed(() => {



    //if (model.efforts.length == 0) return  { start: 0, end: 24*60 }
    if (model.efforts == null) return { start: 0, end: 24 * 60 }

    const x = model.efforts

    const period = TimeSegment.toMinuteNumberArray([x.period], x.offset)

    const start = period[0]

    const end = period[1]

    return { start, end }
})

const endeavours_segmets_strings = computed(() => {

    return TimeSegment.toStrings(endeavours_segments.value)
})


const endeavours_total = computed(() => {

    let total = 0

    endeavours_segments.value.forEach(x => total += x.timespan_min)

    return total
})

const hasEfforts = computed(() => endeavours_total.value > 0)


personViewSetup(setupInternal, setupPreliminary, props, model)



const endeavours_edittable = computed(() => {

    return context.isCurrentPerson()
})


function setupPreliminary() { }

const calendar: { obligations: IObligationUiRow[], timeoffs: ITimeOffUiRow[] } = reactive({ obligations: [], timeoffs: [] })

function setupInternal(p: PersonRmodel) {

    p.flags.timeline = false

    //ui -> read sunrise $date

    const d = model.date;
    const sunrise = Sunrise.DateAsSunrise(d)

    const today = dayjs().startOf('week').toDate()


    context.service.personObligations(p.nid, Sunrise.DateAsSunrise(today), horizon)
        .then(x => {



            calendar.obligations.length = 0
            calendar.timeoffs.length = 0

            for (let index = 0; index < horizon; index++) {

                calendar.obligations.push(
                    {
                        date: today.cloneAndAddDays(index),
                        factual: 0,
                        nominal: 0,
                    })
            }

            calendar.obligations.forEach(r => {

                const item = array.singleOrNull(x.obligations, e => Sunrise.Instance(e.sunrise).equals(Sunrise.DateAsSunrise(r.date)))

                if (item != null) {

                    r.factual = item.factual ?? 0
                    r.nominal = item.nominal
                }
            })

            calendar.timeoffs.replaceWith(x.adjustments.map(a => {

                return {

                    date: Sunrise.Instance(a.sunrise).date(),
                    nominal: a.nominal,
                    factual: a.factual ?? 0,
                    R: a.r != null ? Sunrise.toDate(Sunrise.Instance(a.r)) : null
                }

            }))

        }).catch(sys.exception)


    //read balance on $date - day/alltime
    //hours off (commented: n/a, sick)
    //days off (commented: n/a, vacation, sickleave, etc.)
    context.service.personBalance(p.nid, sunrise)
        .then((b) => {

            controller.balanceSetup(model, b)

        })
        .catch(error => sys.exception(error))


    //read events, tasks, operations and endeavours on $date
    context.service.personEfforts(p.nid, sunrise).then(efforts => {

        if (model.efforts == null) model.efforts = SunriseReportRmodel.Instance(p, efforts.period, efforts, context)

        else model.efforts.setup(context, efforts)

        const r = model.efforts

        //model.efforts.length = 0
        //model.efforts.push(r)

        endeavours_numbers_ui.replaceWith(TimeSegment.toMinuteNumberArray(r.endeavours_Total, r.offset))
        
    }).catch(sys.exception)
}

watch(() => model.date, () => {

    if (context.cursor.person != null) setupInternal(context.cursor.person)
})

function submitDayOff(person: PersonRmodel, sunrise_date: Date) {

    const w = person.workspace.wid

    context.storages.workspace!.personCalendarAdjustmentUpdate(w, person.nid, Sunrise.DateAsSunrise(sunrise_date), 0)

    ui.timeoff.day = false

    setupInternal(person)
}


function submitHourOff(person: PersonRmodel, sunrise_date: Date, minutes: number) {

    console.log('submitHourOff triggered')

    const w = person.workspace.wid

    context.storages.workspace!.personCalendarAdjustmentUpdate(w, person.nid, Sunrise.DateAsSunrise(sunrise_date), minutes)

    ui.timeoff.hour_value = 0
    ui.timeoff.hour = false

    setupInternal(person)
}

// --- SYSTEM TRIGGERS --- //

const handlers: { handler: globalThis.EventListenerOrEventListenerObject, type: string }[] = [];

onUnmounted(() => {

    handlers.forEach(h => context.triggers.cancel(h)); //usubscribe all evernts by mountd instance
})

onBeforeMount(() => {

    let h;

    h = context.triggers.onPersonEffortsUpdated((person, report) => {

        const p = person_model.value

        if (person == p) {

            if (model.efforts != null) {
                const r = model.efforts

                if (r.sunrise.equals2(report.sunrise)) {
                    console.log('update sunrise report')

                    r.setup(context, report)

                    //#trace console.log(r.endeavours_Total)

                    const buffer = TimeSegment.toMinuteNumberArray(r.endeavours_Total, r.offset)

                    if (!endeavours_numbers_ui.areEqual(buffer)) endeavours_numbers_ui.replaceWith(buffer)
                }
            }
        }

    })

    handlers.push(h);
});

function consoleContent(): string {

    if (textbox.value != null) {

        const t = textbox.value;

        return t.value;
    }
    else sys.warn("Can't find console element at page")

    return ''
}

function submit() {

    const p = context.cursor.person

    if (p != null) {
        const wid = p.workspace.wid



        if (model.efforts != null) {

            const v = consoleContent();

            const segment = model.efforts.timespending_timesegment_auto()

            const timespending: Timespending = model.efforts.createTimespending(v, null, segment.timepoint, segment.milliseconds)

            context.storages.workspace!.personTimespendingCreate(timespending.tid, wid, p.nid, timespending)

            consoleContentClear()
        }
        else sys.warn('Empty report model')
    }
}

function esc(args: KeyboardEvent) {

    //sys.info(args.code) //Slash

    if (args.code == 'Escape') {

        consoleContentClear()
        args.preventDefault()
    }

    //args.preventDefault()
}

function consoleContentClear() {

    if (textbox.value != null) {

        const t = textbox.value;
        t.value = ''
    }
    else sys.warn("Can't find console element at page")
}


return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_unref(workspace))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(UserEdeavoursControl, {
              items: _unref(endeavours_user),
              class: "endeavours"
            }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_date_picker, {
                  modelValue: model.date,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.date) = $event))
                }, null, 8, ["modelValue"])
              ]),
              (model.obligations.obligations_total > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("p", null, [
                      _createTextVNode("Balance:"),
                      _createVNode(BalanceComponent, {
                        value: model.obligations.balance,
                        showZeroBalance: true
                      }, null, 8, ["value"])
                    ])
                  ]))
                : (!_unref(person_model)?.isGuest() ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("p", null, "Work: " + _toDisplayString(_unref(mc).toAproximatedHoursString(model.obligations.work)), 1)
                    ]))
                  : _createCommentVNode("", true),
              (!_unref(person_model)?.isGuest() ?? false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", null, "Days off: " + _toDisplayString(model.obligations.offdays), 1),
                    _createElementVNode("p", null, "Hours off: " + _toDisplayString(_unref(mc).toAproximatedHoursString(Math.abs(model.obligations.offhours))), 1)
                  ]))
                : _createCommentVNode("", true),
              (!_unref(person_model)?.isGuest() ?? false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (ui.timeoff.day = !ui.timeoff.day))
                      }, "Day off")
                    ]),
                    _withDirectives(_createElementVNode("div", null, [
                      _hoisted_10,
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (submitDayOff(_unref(person_model)!, model.date)))
                      }, "Yes"),
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (ui.timeoff.day = false))
                      }, "Cacnel")
                    ], 512), [
                      [_vShow, ui.timeoff.day]
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (ui.timeoff.hour = !ui.timeoff.hour))
                      }, "Hours off")
                    ]),
                    _withDirectives(_createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ui.timeoff.hour_value) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          ui.timeoff.hour_value,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _hoisted_11,
                      _hoisted_12,
                      _createElementVNode("button", {
                        disabled: ui.timeoff.hour_value == 0,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (submitHourOff(_unref(person_model)!, model.date, ui.timeoff.hour_value)))
                      }, "Yes", 8, _hoisted_13),
                      _createElementVNode("button", {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (ui.timeoff.hour = false))
                      }, "Cancel")
                    ], 512), [
                      [_vShow, ui.timeoff.hour]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_unref(endeavours_edittable))
                  ? (_openBlock(), _createBlock(EndeavoursComponent, {
                      key: 0,
                      id: "timeline-control",
                      values: _unref(endeavours_numbers_ui),
                      start: _unref(endeavours_period).start,
                      end: _unref(endeavours_period).end,
                      ref: "timeliner",
                      onUpdated: onTimelinerUpdated
                    }, null, 8, ["values", "start", "end"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("button", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (setupInternal(_unref(person_model)!)))
                  }, "REFRESH")
                ], 512), [
                  [_vShow, _unref(person_model)?.flags.timeline ?? false]
                ]),
                _createElementVNode("h1", null, [
                  _createTextVNode(_toDisplayString(model.date.toLocaleString('en-us', { weekday: 'short' })) + ", " + _toDisplayString(model.date.toLocaleString('en-us', { month: 'short' })) + " " + _toDisplayString(model.date.getDate()) + " ", 1),
                  (_unref(endeavours_total) > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" - " + _toDisplayString(_unref(mc).toAproximatedHoursString(_unref(endeavours_total))), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(BalanceComponent, {
                    id: "balance",
                    value: _unref(balance_today),
                    showZeroBalance: false
                  }, null, 8, ["value"])
                ]),
                (_unref(remainder).total_minutes > 0)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("b", null, _toDisplayString(_unref(remainder).period), 1),
                      _withDirectives(_createElementVNode("b", null, "(" + _toDisplayString(_unref(remainder).total) + ")", 513), [
                        [_vShow, _unref(remainder).period_minutes != _unref(remainder).total_minutes]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createVNode(UserEdeavoursControl, { items: _unref(endeavours_segmets_strings) }, null, 8, ["items"])
                ]),
                (_unref(isToday) && _unref(endeavours_total) > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_unref(hasEfforts) && _unref(person_model))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            ((_unref(person_model).efforts?.timespendings_Current.length ?? 0) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createVNode(EventComponent, {
                                    person: _unref(person_model),
                                    level: _unref(user_level)
                                  }, null, 8, ["person", "level"])
                                ]))
                              : (_unref(person_model)?.current != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(TicketCard, {
                                      class: "card-current",
                                      todo: _unref(person_model).current,
                                      "circled-x": true
                                    }, null, 8, ["todo"]),
                                    (model.efforts != null)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (model.efforts.summary.current == null)
                                            ? (_openBlock(), _createElementBlock("h1", _hoisted_21, "BREAK"))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (model.efforts?.summary.current != null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                      _createElementVNode("span", _hoisted_23, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(["bi", _unref(effortCss)(model.efforts.summary.current)])
                                        }, null, 2)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                            (model.efforts?.summary.current != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createElementVNode("span", null, _toDisplayString(model.efforts?.summary.current.timeString_Start()), 1),
                                  _createTextVNode(", "),
                                  _createElementVNode("span", null, _toDisplayString(model.efforts?.summary.current.spanString()), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("input", {
                    type: "text",
                    onKeydown: [
                      _withKeys(submit, ["enter"]),
                      esc
                    ],
                    ref_key: "textbox",
                    ref: textbox
                  }, null, 544)
                ]),
                _createVNode(EffortTimeline, {
                  style: {"margin-top":"1em"},
                  model: model.efforts
                }, null, 8, ["model"])
              ]),
              (!_unref(person_model)?.isGuest() ?? false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendar.obligations, (r, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: r.date.toISOString()
                      }, [
                        _withDirectives(_createElementVNode("p", null, [
                          _createElementVNode("strong", null, _toDisplayString(r.date.toLocaleString('en-us',
                                { month: 'long' })), 1)
                        ], 512), [
                          [_vShow, r.date.getDate() == 1 || index == 0]
                        ]),
                        _createElementVNode("p", {
                          class: _normalizeClass({ 'off': r.nominal == 0, 'today': _unref(Sunrise).DateAsSunrise(r.date).isToday(), 'attention': r.nominal != r.factual && r.nominal > 0 })
                        }, [
                          _createTextVNode(_toDisplayString(r.date.toLocaleString('en-us', { weekday: 'short' })) + ", " + _toDisplayString(r.date.getDate()) + " ", 1),
                          (r.nominal > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (r.factual != 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("- " + _toDisplayString(_unref(mc).toAproximatedHoursString(r.factual)), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_27)),
                                (r.factual != r.nominal)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, " [X]"))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]))
                    }), 128)),
                    (calendar.timeoffs.length > 0)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_29, " Time offs"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendar.timeoffs, (r) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: r.date.toISOString()
                      }, [
                        (r.R != null)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                              _hoisted_31,
                              _createTextVNode(" " + _toDisplayString(_unref(dayjs)(r.date).format('DD MMM')) + " ", 1),
                              _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(r.date.getFullYear()) + ")", 513), [
                                [_vShow, r.date.getFullYear() != new Date().getFullYear()]
                              ]),
                              _createTextVNode(),
                              _hoisted_32,
                              _createTextVNode(" " + _toDisplayString(_unref(dayjs)(r.R!).format('DD MMM')), 1)
                            ]))
                          : (r.factual == 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                                _hoisted_34,
                                _createTextVNode(" " + _toDisplayString(_unref(dayjs)(r.date).format('DD MMM')) + " ", 1),
                                _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(r.date.getFullYear()) + ")", 513), [
                                  [_vShow, r.date.getFullYear() != new Date().getFullYear()]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_35, [
                                _createTextVNode(_toDisplayString(_unref(dayjs)(r.date).format('DD MMM')) + " ", 1),
                                _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(r.date.getFullYear()) + ")", 513), [
                                  [_vShow, r.date.getFullYear() != new Date().getFullYear()]
                                ]),
                                _createTextVNode(" - " + _toDisplayString(_unref(mc).toAproximatedHoursString(r.factual)), 1)
                              ]))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode(EffortStatusComponent, {
            status: model.efforts?.summary ?? null
          }, null, 8, ["status"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})